import { useCallback } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import useBannerReady from './useBannerReady';

export default function useSendViewedBannerEvent() {
  const bannerReady = useBannerReady();
  const trackEvent = useTrackEvent();

  return useCallback(
    (bannerName: string, additionalCustomAttributes?: Record<string, any>) => {
      if (!bannerReady) return;

      trackEvent('Viewed - Banner', {
        ...additionalCustomAttributes,
        category: bannerName
      });
    },
    [bannerReady, trackEvent]
  );
}
